<template>

  <v-container fluid :class="contactContainerClass">
    
    <v-slide-y-transition mode="out-in">
      <router-view />
    </v-slide-y-transition>
   

  </v-container>
  

</template>

<script>
import { childOfOrEqualDetails } from "./router/routes";

import { mapGetters } from "vuex";


import * as I18nActionTypes from "../../store/app/i18n/types";
import { createModalMixin ,closeModalRoute } from '../../dt-plugins/modal/modal.mixin';

export default {
  components: {

  },
  mounted: function () {
    this.$store.dispatch(I18nActionTypes.INSERT_SYSTEM_LANGUAGE_SECTION, [
      // "promotion",
      // "label",
      // "royalty",
       "settings"
     // "main"
    ]);
  },
  mixins: [
 
  ],
  computed: {
    contactContainerClass: function () {
      return {
        "dt-module": true,
        inactive: childOfOrEqualDetails(this.$route),
      };
    },
  },
  methods: {
    //MARK: Methods
    onCancel: function () {
     closeModalRoute(this);
    },
  },
};
</script>

